/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from 'react';
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';
import { Button, Card, CardActions, CardContent, CardHeader, Grid, IconButton, Input, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import { Edit, Code, Cancel } from '@mui/icons-material';
import { Skeleton } from '@albo-ui/core'

const ScriptData = (props) => {
    const [type, setType] = useState('');
    const [script, setScript] = useState('');
    const [edit, setEdit] = useState(false);
    const history = useHistory();
    
    useEffect(() => {
        init();
    }, [props.content]);

    const init = () => {
        if(props.content.type){
            setType(props.content.type);
        }
        if(props.content.script){
            let buff = Buffer.from(props.content.script, 'base64');
            let str = buff.toString('utf-8');
            setScript(str);
        }
        setEdit(false);
    }

    const changeTab = async (e, value) => {
        setType(value);
        await reloadData({type: value});
    }

    const reloadData = async (data) => {
        props.changeLoader(true);
        let request = await API.service('adminScripts', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    
        props.changeLoader(false);
    };

    const change = () => {
        setEdit(!edit);
    }

    const changeScript = (e) => {
        setScript(e.target.value);
    }

    const updateScript = async () => {
        props.changeLoader(true);
        let newscript = Buffer.from(script).toString('base64');
        let data = {
            type: type,
            script: newscript,
            version: props.content.version,
        }
        let request = await API.service('updateScript', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            await reloadData({});
        }
    
        props.changeLoader(false);
    }

    return <Card sx={{width: '100%', padding: "1vw"}}>
        <CardHeader
            sx={{width: '100%', my: "1vw"}}
            title={
                <Typography variant='h2' style={{ display: 'inline-flex', alignItems: 'center', fontSize: '1.2rem' }} fontWeight={600}>
                    <Code sx={{ marginRight: 1 }} /> Administrador Scripts
                </Typography>
            }
            action={
                <div style={{margin: '40px !important'}}>
                    <Tooltip title={edit ? 'Cancelar' : 'Editar'}>
                        <IconButton sx={{marginLeft: '-50px !important', marginTop: '15px !important'}} onClick={change.bind(this)}>
                            {
                                !edit &&
                                <Edit/>
                            }
                            {
                                edit &&
                                <Cancel/>
                            }
                        </IconButton>
                    </Tooltip>
                </div>
            }
        />
        <CardContent>
            {type ?
                <Tabs value={type} sx={{width: '100%'}} variant='fullWidth' indicatorColor='secondary' textColor='secondary' onChange={changeTab}>
                    <Tab 
                        label={
                            <Typography
                                component={'span'} 
                                fontFamily="Muli,sans-serif"
                                fontSize="13px"
                                fontWeight={600}
                                //sx={{color: '#3E3E42', marginLeft: '0.5%'}}
                                sx={{textTransform: 'none'}}
                            >
                                High Level
                            </Typography>
                        } 
                        value={'highlevel'}
                    />
                    <Tab 
                        label={
                            <Typography
                                component={'span'} 
                                fontFamily="Muli,sans-serif"
                                fontSize="13px"
                                fontWeight={600}
                                //sx={{color: '#3E3E42', marginLeft: '0.5%'}}
                                sx={{textTransform: 'none'}}
                            >
                                Low Level
                            </Typography>
                        } 
                        value={'lowlevel'}
                    />
                    <Tab 
                        label={
                            <Typography
                                component={'span'} 
                                fontFamily="Muli,sans-serif"
                                fontSize="13px"
                                fontWeight={600}
                                //sx={{color: '#3E3E42', marginLeft: '0.5%'}}
                                sx={{textTransform: 'none'}}
                            >
                                Dominios
                            </Typography>
                        } 
                        value={'domain'}
                    />
                    <Tab 
                        label={
                            <Typography
                                component={'span'} 
                                fontFamily="Muli,sans-serif"
                                fontSize="13px"
                                fontWeight={600}
                                //sx={{color: '#3E3E42', marginLeft: '0.5%'}}
                                sx={{textTransform: 'none'}}
                            >
                                Funciones
                            </Typography>
                        } 
                        value={'function'}
                    />  
                </Tabs>
                :
                <Skeleton width='100%' height='100px' />
                    
            }
            <Grid container>
                {
                    edit &&
                    <Input
                        type='text'
                        color='secondary'
                        fullWidth
                        value={script}
                        multiline
                        onChange={changeScript.bind(this)}
                    />
                }
                {
                    !edit &&
                    <pre>
                        {script}
                    </pre>
                }
            </Grid>
        </CardContent>
        {
            edit &&
            <CardActions>
                <Button color='secondary' variant='contained' sx={{textTransform: 'none'}} onClick={updateScript.bind(this)}>Aceptar</Button>
            </CardActions>
        }
    </Card>
}

export default ScriptData;